import type { ExcelAction } from "./types";
import { openTraceDialog } from "../dialog-host";

export const traceCell: ExcelAction = {
  id: "trace-cell",
  label: "Trace cell",
  description:
    "Show the active cell's precedents and dependents in a dialog; click any row to navigate and re-trace.",
  async run({ log }) {
    log("opening cell trace...");
    try {
      await openTraceDialog();
      log("trace closed");
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`trace failed: ${message}`, "error");
    }
  },
};
